export default __webpack_public_path__ + "static/media/raiffeisen_grid_xl.01d8386d.jpg";